























import {Component, Vue, Prop} from 'vue-property-decorator';
import t from '@/i18n/translations'

const progressNamespace = 'progress';

@Component({})

export default class ProgressFooter extends Vue {
    @Prop({}) data: any;
    @Prop({default: false}) isConfirm: boolean | undefined;
    i18n = t["nl"];
}

